import React from 'react'
import LandingCars from '../../modules/v1/landingCars'

export default props => <LandingCars {...props} />
